import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiChevronDown } = FiIcons;

const CollapsibleSection = ({ 
  title, 
  children, 
  defaultExpanded = false, 
  expanded, 
  onToggle, 
  headerColor = 'bg-neo-blue', 
  className = '' 
}) => {
  const [internalExpanded, setInternalExpanded] = useState(defaultExpanded);
  
  const isExpanded = expanded !== undefined ? expanded : internalExpanded;

  const toggleExpanded = () => {
    if (expanded === undefined) {
      setInternalExpanded(!isExpanded);
    }
    if (onToggle) {
      onToggle(!isExpanded);
    }
  };

  return (
    <div className={`neo-card p-0 ${className}`}>
      <div
        className={`neo-window-header flex items-center justify-between min-h-[44px] cursor-pointer ${headerColor}`}
        onClick={toggleExpanded}
      >
        <span className="text-xs font-bold uppercase flex-1" style={{ backgroundColor: 'inherit' }}>
          {title}
        </span>
        <motion.div
          animate={{ rotate: isExpanded ? 180 : 0 }}
          transition={{ duration: 0.3 }}
        >
          <SafeIcon
            icon={FiChevronDown}
            size={16}
          />
        </motion.div>
      </div>

      <AnimatePresence initial={false}>
        {isExpanded && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3, ease: "easeInOut" }}
            className="overflow-hidden"
          >
            <div className="bg-white p-4">
              {children}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default CollapsibleSection;
